import React from 'react'
import { Field } from 'formik'

import { Textarea as TWTextarea } from '../../../../../components/Textarea'

export const Textarea = props => (
    <div className="mb-[15px]">
        {props?.label?.length > 0 && props?.type !== 'hidden' && (
            <p className="mb-[8px]">
                {props.label}
                {props.required && <sup className="text-brand-danger">*</sup>}
            </p>
        )}

        <Field name={props.name}>
            {({ field, form }) => (
                <TWTextarea
                    onChange={e => form.setFieldValue(field.name, e.target.value)}
                    isDisabled={form.isSubmitting || props.disabled}
                    value={field.value}
                    {...props}
                />
            )}
        </Field>
        {props?.help?.length > 0 && (
            <p className="text-brand-dark-grey text-[12px] mb-[15px]">{props.help}</p>
        )}
    </div>
)
